import liveSessioner from '../livesession/LiveSessioner';
import utilService from '../UtilService';

let isListening = false;

/**
 * This function can be removed, unlike .bind(this) which returns a new function
 * upon every call.
 */
function tryToSendRequiredStream(vccMessageEvent) {
    videoChatControllerIframeService.tryToSendRequiredStream(vccMessageEvent);
}

window.receiveStreamFromIframe = function (stream) {
    liveSessioner.setExaminerRemoteStream(stream);
};

const videoChatControllerIframeService = {
    isStreamStopNeeded(url) {
        return !(/\?(?:.+&)?(type|password)=WebRTC(&|$)/.test(url));
    },

    shouldSendStreamAndGetSource(vccMessageEvent) {
        // Ignore cross-origin messages.
        if (!utilService.isSameOriginMessageEvent(vccMessageEvent.origin)) {
            return null;
        }

        const message = vccMessageEvent.data;

        // It is only interested of the Video Chat Controller message.
        if (
            typeof message !== 'object'
            || message == null
            || message.type !== 'vcc-ready'
        ) {
            return null;
        }

        /**
         * Share the video & audio stream with WebRTC Video Chat Controller.
         * Only WebRTC app will make the initWithCameraMicStream function
         * available.
         */
        const iframe = vccMessageEvent.source;

        if (
            iframe == null
            || typeof iframe.initWithCameraMicStream !== 'function'
        ) {
            return null;
        }

        return iframe;
    },

    tryToSendRequiredStream(vccMessageEvent) {
        const iframe = this.shouldSendStreamAndGetSource(vccMessageEvent);

        if (!iframe) {
            return;
        }

        /**
         * Safe because liveSessioner.stopStream() changes getGrantedStream
         * into null.
         */
        iframe.initWithCameraMicStream(liveSessioner.getGrantedStream());
    },

    addReadyListener() {
        if (isListening) {
            return;
        }

        window.addEventListener('message', tryToSendRequiredStream, false);
        isListening = true;
    },

    removeReadyListener() {
        if (!isListening) {
            return;
        }

        window.removeEventListener('message', tryToSendRequiredStream, false);
        isListening = false;
    },
};

export default videoChatControllerIframeService;
